import { render, staticRenderFns } from "./RuleSlotAdding.vue?vue&type=template&id=24461496"
import script from "./RuleSlotAdding.vue?vue&type=script&lang=js"
export * from "./RuleSlotAdding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports